import { intercom } from '@anm/helpers/intercom';
import { LiveStreamKind } from 'types/stream';

const trackIntercom = (eventName: string, metadata?: {}) => intercom('trackEvent', eventName, metadata);
const trackIntercomKind = (eventName: string) => (kind: LiveStreamKind) => trackIntercom(eventName, { type: kind });

export const trackIntercomStudioOpen = () => trackIntercom('app.studio.open');
export const trackIntercomStreamStart = trackIntercomKind('app.studio.stream.start');
export const trackIntercomStreamCreate = trackIntercomKind('app.studio.stream.create');
